export default {
    bind($item, $bind, $vue) {
        $vue.context.$on('user-restricted-event', data => {
            if (data === $item.dataset.label) {
                $item.style.display = "block";
            }
        });
    }
}
